import React from 'react';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

function deleteOrg (props) {    
          return(
                    <div>
                        <div className="text">
                                <button className="btn"  onClick={()=>props.toggle()}>
                                            No
                                </button>
                                <button className="danger-button" onClick={()=>props.deleteOrg()}>
                                            Yes
                                </button>
                        </div>
                    </div>
          )
}
export default deleteOrg